import { useRouteMatch as useRouteMatchDOM } from 'react-router-dom';

import { useLink } from './useLink';

export function useRouteMatch<
	Params extends { [K in keyof Params]?: string } = NonNullable<unknown>,
>(path: string) {
	path = useLink(path)!;
	return useRouteMatchDOM<Params>(path);
}
